<div class="p-2 w-100">
  
    <!-- Header minimalista -->
    <div class="uncp-header text-white p-4 mb-4">
        <div class="d-flex justify-content-between align-items-center">
        <div>
            <h3 class="mb-1 fw-light">
            <i class="fas fa-file-alt me-2"></i>
            Solicitudes de Acceso a la Información Pública
            </h3>
            <p class="mb-0 opacity-75">Gestión y seguimiento de solicitudes bajo la Ley de Transparencia N° 27806</p>
        </div>
        <div class="d-flex gap-2">
            <button class="btn btn-outline-light" data-bs-toggle="modal" data-bs-target="#modalReporteSolicitudes">
                <i class="fas fa-chart-bar me-1"></i>
                Reportes
            </button>
            <button class="btn btn-light uncp-btn" data-bs-toggle="modal" data-bs-target="#modalNuevaSolicitud">
                <i class="fas fa-plus me-1"></i>
                Nueva Solicitud Manual
            </button>
        </div>
        </div>
    </div>

    <!-- Estadísticas rápidas -->
    <div class="row mb-4">
        <div class="col-md-3">
            <div class="card border-0 shadow-sm">
                <div class="card-body py-3">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center">
                            <i class="fas fa-file-alt text-primary fs-4 me-3"></i>
                            <div>
                                <h6 class="mb-0 fw-bold">Total</h6>
                                <span class="text-muted small">Solicitudes</span>
                            </div>
                        </div>
                        <span class="badge bg-primary fs-5 px-3 py-2">324</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card border-0 shadow-sm">
                <div class="card-body py-3">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center">
                            <i class="fas fa-hourglass-half text-warning fs-4 me-3"></i>
                            <div>
                                <h6 class="mb-0 fw-bold">En proceso</h6>
                                <span class="text-muted small">Evaluación</span>
                            </div>
                        </div>
                        <span class="badge bg-warning fs-5 px-3 py-2">18</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card border-0 shadow-sm">
                <div class="card-body py-3">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center">
                            <i class="fas fa-check-circle text-success fs-4 me-3"></i>
                            <div>
                                <h6 class="mb-0 fw-bold">Atendidas</h6>
                                <span class="text-muted small">Este mes</span>
                            </div>
                        </div>
                        <span class="badge bg-success fs-5 px-3 py-2">45</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card border-0 shadow-sm">
                <div class="card-body py-3">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center">
                            <i class="fas fa-exclamation-circle text-danger fs-4 me-3"></i>
                            <div>
                                <h6 class="mb-0 fw-bold">Vencidas</h6>
                                <span class="text-muted small">Plazo legal</span>
                            </div>
                        </div>
                        <span class="badge bg-danger fs-5 px-3 py-2">2</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Controles de búsqueda y filtros -->
    <div class="row mx-0 mb-3 align-items-center">
        <div class="col-md-4 px-1">
            <div class="input-group">
                <span class="input-group-text"><i class="fas fa-search"></i></span>
                <input type="text" class="form-control" placeholder="Buscar por N° solicitud, solicitante o DNI...">
            </div>
        </div>
        <div class="col-md-2 px-1 mt-2 mt-md-0">
            <select class="form-select">
                <option value="">Todos los tipos</option>
                <option value="persona-natural">Persona Natural</option>
                <option value="persona-juridica">Persona Jurídica</option>
                <option value="periodista">Periodista</option>
                <option value="investigador">Investigador</option>
            </select>
        </div>
        <div class="col-md-2 px-1 mt-2 mt-md-0">
            <select class="form-select">
                <option value="">Todos los estados</option>
                <option value="recibida">Recibida</option>
                <option value="en-proceso">En Proceso</option>
                <option value="atendida">Atendida</option>
                <option value="denegada">Denegada</option>
                <option value="derivada">Derivada</option>
                <option value="vencida">Vencida</option>
            </select>
        </div>
        <div class="col-md-2 px-1 mt-2 mt-md-0">
            <select class="form-select">
                <option value="">Fecha</option>
                <option value="2025-01">Enero 2025</option>
                <option value="2025-02">Febrero 2025</option>
                <option value="2025-03">Marzo 2025</option>
                <option value="ultimos-7-dias">Últimos 7 días</option>
                <option value="ultimos-30-dias">Últimos 30 días</option>
            </select>
        </div>
        <div class="col-md-2 px-1 text-md-end mt-2 mt-md-0">
            <div class="d-flex align-items-center justify-content-md-end">
                <span class="me-2 small text-muted">Mostrar:</span>
                <select class="form-select form-select-sm w-auto">
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                </select>
            </div>
        </div>
    </div>

    <!-- Tabla -->
    <div class="card uncp-card">
        <div class="table-responsive">
            <table class="table table-hover uncp-table mb-0">
                <thead>
                    <tr>
                        <th style="min-width: 60px;">N° Solicitud</th>
                        <th>Solicitante</th>
                        <th class="d-none d-lg-table-cell">Información Solicitada</th>
                        <th class="d-none d-md-table-cell">Tipo</th>
                        <th>Fecha Solicitud</th>
                        <th class="text-center">Días Restantes</th>
                        <th class="text-center">Estado</th>
                        <th class="text-center" style="width: 140px;">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- Datos de ejemplo -->
                    <tr>
                        <td class="fw-bold text-primary">2025-001</td>
                        <td>
                            <div class="d-flex align-items-center">
                                <i class="fas fa-user text-uncp me-2 fa-lg"></i>
                                <div>
                                    <div class="fw-medium">GARCÍA MENDOZA, JUAN CARLOS</div>
                                    <small class="text-muted">DNI: 43567890 | juan.garcia&#64;email.com</small>
                                </div>
                            </div>
                        </td>
                        <td class="d-none d-lg-table-cell">
                            <div class="small">
                                <div class="fw-medium">Presupuesto institucional 2025</div>
                                <small class="text-muted">Ejecución presupuestal del ejercicio fiscal...</small>
                            </div>
                        </td>
                        <td class="d-none d-md-table-cell">
                            <span class="badge bg-info">Persona Natural</span>
                        </td>
                        <td>
                            <div class="small">
                                <div><strong>08/01/2025</strong></div>
                                <div class="text-muted">09:15 AM</div>
                            </div>
                        </td>
                        <td class="text-center">
                            <span class="badge bg-success">5 días</span>
                        </td>
                        <td class="text-center">
                            <span class="badge bg-warning">En Proceso</span>
                        </td>
                        <td class="text-center">
                            <div class="btn-group btn-group-sm">
                                <button class="btn btn-outline-success" title="Procesar solicitud" data-bs-toggle="modal" data-bs-target="#modalProcesarSolicitud">
                                    <i class="fas fa-cog"></i>
                                </button>
                                <button class="btn btn-outline-info" title="Ver detalles" data-bs-toggle="modal" data-bs-target="#modalDetallesSolicitud">
                                    <i class="fas fa-eye"></i>
                                </button>
                                <button class="btn btn-outline-primary" title="Descargar PDF" onclick="descargarPDF('2025-001')">
                                    <i class="fas fa-download"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="fw-bold text-primary">2025-002</td>
                        <td>
                            <div class="d-flex align-items-center">
                                <i class="fas fa-building text-uncp me-2 fa-lg"></i>
                                <div>
                                    <div class="fw-medium">CORPORACIÓN MINERA SAC</div>
                                    <small class="text-muted">RUC: 20123456789 | contacto&#64;corporacion.com</small>
                                </div>
                            </div>
                        </td>
                        <td class="d-none d-lg-table-cell">
                            <div class="small">
                                <div class="fw-medium">Contratos de investigación minera</div>
                                <small class="text-muted">Convenios suscritos con empresas del sector...</small>
                            </div>
                        </td>
                        <td class="d-none d-md-table-cell">
                            <span class="badge bg-primary">Persona Jurídica</span>
                        </td>
                        <td>
                            <div class="small">
                                <div><strong>05/01/2025</strong></div>
                                <div class="text-muted">14:30 PM</div>
                            </div>
                        </td>
                        <td class="text-center">
                            <span class="badge bg-success">8 días</span>
                        </td>
                        <td class="text-center">
                            <span class="badge bg-success">Atendida</span>
                        </td>
                        <td class="text-center">
                            <div class="btn-group btn-group-sm">
                                <button class="btn btn-outline-success" title="Ver respuesta" data-bs-toggle="modal" data-bs-target="#modalVerRespuesta">
                                    <i class="fas fa-check-circle"></i>
                                </button>
                                <button class="btn btn-outline-info" title="Ver detalles" data-bs-toggle="modal" data-bs-target="#modalDetallesSolicitud">
                                    <i class="fas fa-eye"></i>
                                </button>
                                <button class="btn btn-outline-primary" title="Descargar PDF" onclick="descargarPDF('2025-002')">
                                    <i class="fas fa-download"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="fw-bold text-primary">2025-003</td>
                        <td>
                            <div class="d-flex align-items-center">
                                <i class="fas fa-newspaper text-uncp me-2 fa-lg"></i>
                                <div>
                                    <div class="fw-medium">RODRIGUEZ SILVA, ANA MARÍA</div>
                                    <small class="text-muted">DNI: 25789456 | Periodista - Diario El Centro</small>
                                </div>
                            </div>
                        </td>
                        <td class="d-none d-lg-table-cell">
                            <div class="small">
                                <div class="fw-medium">Gastos en viáticos y movilidad</div>
                                <small class="text-muted">Detalle de gastos del rector y vicerrectores...</small>
                            </div>
                        </td>
                        <td class="d-none d-md-table-cell">
                            <span class="badge bg-warning">Periodista</span>
                        </td>
                        <td>
                            <div class="small">
                                <div><strong>03/01/2025</strong></div>
                                <div class="text-muted">16:45 PM</div>
                            </div>
                        </td>
                        <td class="text-center">
                            <span class="badge bg-danger">-2 días</span>
                        </td>
                        <td class="text-center">
                            <span class="badge bg-danger">Vencida</span>
                        </td>
                        <td class="text-center">
                            <div class="btn-group btn-group-sm">
                                <button class="btn btn-outline-danger" title="Procesar urgente" data-bs-toggle="modal" data-bs-target="#modalProcesarUrgente">
                                    <i class="fas fa-exclamation-triangle"></i>
                                </button>
                                <button class="btn btn-outline-info" title="Ver detalles" data-bs-toggle="modal" data-bs-target="#modalDetallesSolicitud">
                                    <i class="fas fa-eye"></i>
                                </button>
                                <button class="btn btn-outline-primary" title="Descargar PDF" onclick="descargarPDF('2025-003')">
                                    <i class="fas fa-download"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="fw-bold text-primary">2025-004</td>
                        <td>
                            <div class="d-flex align-items-center">
                                <i class="fas fa-graduation-cap text-uncp me-2 fa-lg"></i>
                                <div>
                                    <div class="fw-medium">TORRES VALDEZ, LUIS ALBERTO</div>
                                    <small class="text-muted">DNI: 18234567 | Investigador - CONCYTEC</small>
                                </div>
                            </div>
                        </td>
                        <td class="d-none d-lg-table-cell">
                            <div class="small">
                                <div class="fw-medium">Proyectos de investigación aprobados</div>
                                <small class="text-muted">Lista de proyectos con financiamiento 2024...</small>
                            </div>
                        </td>
                        <td class="d-none d-md-table-cell">
                            <span class="badge bg-success">Investigador</span>
                        </td>
                        <td>
                            <div class="small">
                                <div><strong>10/01/2025</strong></div>
                                <div class="text-muted">11:20 AM</div>
                            </div>
                        </td>
                        <td class="text-center">
                            <span class="badge bg-warning">3 días</span>
                        </td>
                        <td class="text-center">
                            <span class="badge bg-info">Recibida</span>
                        </td>
                        <td class="text-center">
                            <div class="btn-group btn-group-sm">
                                <button class="btn btn-outline-primary" title="Asignar responsable" data-bs-toggle="modal" data-bs-target="#modalAsignarResponsable">
                                    <i class="fas fa-user-plus"></i>
                                </button>
                                <button class="btn btn-outline-info" title="Ver detalles" data-bs-toggle="modal" data-bs-target="#modalDetallesSolicitud">
                                    <i class="fas fa-eye"></i>
                                </button>
                                <button class="btn btn-outline-primary" title="Descargar PDF" onclick="descargarPDF('2025-004')">
                                    <i class="fas fa-download"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <!-- Paginación -->
    <div class="d-flex justify-content-between align-items-center mt-3">
        <div class="text-muted small">
            Mostrando 1 a 20 de 324 solicitudes
        </div>
        <nav>
            <ul class="pagination pagination-sm mb-0">
                <li class="page-item disabled">
                <a class="page-link" style="cursor:pointer;">
                    <i class="fas fa-angle-double-left"></i>
                </a>
                </li>
                <li class="page-item disabled">
                <a class="page-link" style="cursor:pointer;">
                    <i class="fas fa-chevron-left"></i>
                </a>
                </li>
                <li class="page-item active">
                <a class="page-link" style="cursor:pointer;">1</a>
                </li>
                <li class="page-item">
                <a class="page-link" style="cursor:pointer;">2</a>
                </li>
                <li class="page-item">
                <a class="page-link" style="cursor:pointer;">3</a>
                </li>
                <li class="page-item">
                <a class="page-link" style="cursor:pointer;">
                    <i class="fas fa-chevron-right"></i>
                </a>
                </li>
                <li class="page-item">
                <a class="page-link" style="cursor:pointer;">
                    <i class="fas fa-angle-double-right"></i>
                </a>
                </li>
            </ul>
        </nav>
    </div>

</div>

<!-- Modal Nueva Solicitud -->
<div class="modal fade" id="modalNuevaSolicitud" tabindex="-1" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header bg-uncp text-white">
                <h5 class="modal-title">
                <i class="fas fa-plus-circle me-2"></i>
                Nueva Solicitud Manual
                </h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
            </div>
            
            <form novalidate>
                <div class="modal-body p-4">
                    <div class="row">
                        <!-- Datos del Solicitante -->
                        <div class="col-12 mb-4">
                            <div class="card border-primary">
                                <div class="card-header bg-primary text-white py-2">
                                    <h6 class="mb-0">
                                        <i class="fas fa-user me-2"></i>
                                        Datos del Solicitante
                                    </h6>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-8 mb-3">
                                            <label class="form-label">Apellidos y Nombres / Razón Social <span class="text-danger">*</span></label>
                                            <input type="text" class="form-control" placeholder="Ingrese nombres completos o razón social">
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <label class="form-label">Tipo de Documento <span class="text-danger">*</span></label>
                                            <select class="form-select">
                                                <option value="">Seleccione...</option>
                                                <option value="DNI">D.N.I.</option>
                                                <option value="RUC">R.U.C.</option>
                                                <option value="CE">C.E.</option>
                                                <option value="OTRO">Otro</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-3 mb-3">
                                            <label class="form-label">N° Documento <span class="text-danger">*</span></label>
                                            <input type="text" class="form-control" placeholder="Número">
                                        </div>
                                        <div class="col-md-3 mb-3">
                                            <label class="form-label">Teléfono</label>
                                            <input type="text" class="form-control" placeholder="Teléfono">
                                        </div>
                                        <div class="col-md-6 mb-3">
                                            <label class="form-label">Correo Electrónico</label>
                                            <input type="email" class="form-control" placeholder="correo&#64;ejemplo.com">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Información Solicitada -->
                        <div class="col-12 mb-4">
                            <div class="card border-success">
                                <div class="card-header bg-success text-white py-2">
                                    <h6 class="mb-0">
                                        <i class="fas fa-info-circle me-2"></i>
                                        Información Solicitada
                                    </h6>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-12 mb-3">
                                            <label class="form-label">Tipo de Información <span class="text-danger">*</span></label>
                                            <select class="form-select" required>
                                                <option value="">Seleccione el tipo...</option>
                                                <option value="presupuestal">Información Presupuestal</option>
                                                <option value="contratos">Contratos y Adquisiciones</option>
                                                <option value="personal">Información de Personal</option>
                                                <option value="academica">Información Académica</option>
                                                <option value="investigacion">Proyectos de Investigación</option>
                                                <option value="otra">Otra información</option>
                                            </select>
                                        </div>
                                        <div class="col-12 mb-3">
                                            <label class="form-label">Descripción Detallada <span class="text-danger">*</span></label>
                                            <textarea class="form-control" rows="4" placeholder="Describa detalladamente la información que solicita..." required></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Datos de la Solicitud -->
                        <div class="col-12">
                            <h6 class="text-uncp mb-3 pb-2 border-bottom">
                                <i class="fas fa-file-alt me-2"></i>
                                Datos de la Solicitud
                            </h6>
                        </div>
                        
                        <div class="col-md-4 mb-3">
                            <label class="form-label">N° de Solicitud <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" placeholder="Se generará automáticamente" readonly>
                        </div>
                        
                        <div class="col-md-4 mb-3">
                            <label class="form-label">Fecha de Solicitud</label>
                            <input type="date" class="form-control" value="2025-01-13" readonly>
                        </div>
                        
                        <div class="col-md-4 mb-3">
                            <label class="form-label">Prioridad</label>
                            <select class="form-select">
                                <option value="normal">Normal (10 días)</option>
                                <option value="urgente">Urgente (7 días)</option>
                            </select>
                        </div>
                        
                        <div class="col-md-6 mb-3">
                            <label class="form-label">Modalidad de Entrega <span class="text-danger">*</span></label>
                            <select class="form-select" required>
                                <option value="">Seleccione modalidad...</option>
                                <option value="presencial">Entrega presencial</option>
                                <option value="correo">Envío por correo electrónico</option>
                                <option value="plataforma">Descarga desde plataforma web</option>
                            </select>
                        </div>
                        
                        <div class="col-md-6 mb-3">
                            <label class="form-label">Formato de Entrega</label>
                            <select class="form-select">
                                <option value="digital">Digital (PDF, Excel, Word)</option>
                                <option value="fisico">Físico (Impreso)</option>
                                <option value="ambos">Ambos formatos</option>
                            </select>
                        </div>
                        
                        <div class="col-12 mb-3">
                            <label class="form-label">Observaciones Adicionales</label>
                            <textarea class="form-control" rows="3" placeholder="Observaciones o consideraciones especiales (opcional)..."></textarea>
                        </div>
                        
                        <!-- Documentos Adjuntos -->
                        <div class="col-12 mb-3">
                            <h6 class="text-uncp mb-3">
                                <i class="fas fa-paperclip me-2"></i>
                                Documentos de Identidad (Opcional)
                            </h6>
                            <div class="card border-dashed">
                                <div class="card-body text-center py-4">
                                    <i class="fas fa-cloud-upload-alt fa-3x text-muted mb-3"></i>
                                    <p class="mb-2">Arrastra y suelta archivos aquí o</p>
                                    <button type="button" class="btn btn-outline-primary">
                                        <i class="fas fa-folder-open me-1"></i>
                                        Seleccionar Archivos
                                    </button>
                                    <p class="small text-muted mt-2">Copia de DNI, RUC u otros documentos de identidad (PDF, JPG, PNG - Máx. 5MB)</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                        Cancelar
                    </button>
                    <button type="button" class="btn btn-warning me-2">
                        <i class="fas fa-save me-1"></i>
                        Guardar Borrador
                    </button>
                    <button type="submit" class="btn btn-success">
                        <i class="fas fa-paper-plane me-1"></i>
                        Registrar Solicitud
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Modal Procesar Solicitud -->
<div class="modal fade" id="modalProcesarSolicitud" tabindex="-1" data-bs-backdrop="static">
    <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header bg-success text-white">
                <h5 class="modal-title">
                <i class="fas fa-cog me-2"></i>
                Procesar Solicitud - N° 2025-001
                </h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
            </div>
            
            <form novalidate>
                <div class="modal-body p-4">
                    <div class="row">
                        <!-- Información de la Solicitud -->
                        <div class="col-12 mb-4">
                            <div class="card bg-light">
                                <div class="card-body py-3">
                                    <div class="row align-items-center">
                                        <div class="col-md-8">
                                            <h6 class="mb-1 fw-bold">SOLICITUD N° 2025-001</h6>
                                            <p class="mb-1">Presupuesto institucional 2025 - Ejecución presupuestal del ejercicio fiscal</p>
                                            <p class="mb-0 text-muted">GARCÍA MENDOZA, JUAN CARLOS - DNI: 43567890</p>
                                        </div>
                                        <div class="col-md-4 text-md-end">
                                            <div class="fw-bold text-primary">Fecha: 08/01/2025</div>
                                            <div class="text-muted">Días restantes: <span class="badge bg-success">5</span></div>
                                            <div class="text-muted">Estado: <span class="badge bg-warning">En Proceso</span></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Respuesta a la Solicitud -->
                        <div class="col-12">
                            <div class="row">
                                <div class="col-md-6">
                                    <h6 class="text-uncp mb-3 pb-2 border-bottom">
                                        <i class="fas fa-reply me-2"></i>
                                        Estado de la Solicitud
                                    </h6>
                                    
                                    <div class="mb-3">
                                        <label class="form-label fw-medium">Decisión <span class="text-danger">*</span></label>
                                        <select class="form-select" required>
                                            <option value="">Seleccione una decisión...</option>
                                            <option value="atender">Atender Solicitud</option>
                                            <option value="denegar">Denegar Solicitud</option>
                                            <option value="derivar">Derivar a Otra Entidad</option>
                                            <option value="informacion-inexistente">Información Inexistente</option>
                                            <option value="solicitar-aclaracion">Solicitar Aclaración</option>
                                        </select>
                                    </div>
                                    
                                    <div class="mb-3">
                                        <label class="form-label fw-medium">Fecha de Respuesta</label>
                                        <input type="date" class="form-control" value="2025-01-13">
                                    </div>
                                    
                                    <div class="mb-3">
                                        <label class="form-label fw-medium">Modalidad de Entrega</label>
                                        <select class="form-select">
                                            <option value="presencial">Entrega Presencial</option>
                                            <option value="correo">Envío por Correo</option>
                                            <option value="plataforma">Plataforma Web</option>
                                        </select>
                                    </div>
                                    
                                    <div class="mb-3">
                                        <label class="form-label fw-medium">Responsable de la Respuesta</label>
                                        <select class="form-select">
                                            <option value="">Asignar responsable...</option>
                                            <option value="oai">Oficina de Acceso a la Información</option>
                                            <option value="planificacion">Oficina de Planificación</option>
                                            <option value="recursos-humanos">Recursos Humanos</option>
                                            <option value="logistica">Logística</option>
                                        </select>
                                    </div>
                                    
                                    <div class="mb-3">
                                        <label class="form-label fw-medium">Costo de Reproducción (S/)</label>
                                        <input type="number" class="form-control" placeholder="0.00" step="0.01">
                                        <small class="text-muted">Solo si aplica costo por reproducción</small>
                                    </div>
                                </div>
                                
                                <div class="col-md-6">
                                    <h6 class="text-uncp mb-3 pb-2 border-bottom">
                                        <i class="fas fa-user-tie me-2"></i>
                                        Responsable de la Conformidad
                                    </h6>
                                    
                                    <div class="mb-3">
                                        <label class="form-label fw-medium">Funcionario Responsable</label>
                                        <select class="form-select" required>
                                            <option value="">Seleccionar funcionario...</option>
                                            <option value="1" selected>Ing. Miguel Ángel Hurtado Sánchez</option>
                                            <option value="2">Lic. Ana María Torres López</option>
                                            <option value="3">Mg. Carlos Roberto Mendoza</option>
                                        </select>
                                    </div>
                                    
                                    <div class="mb-3">
                                        <label class="form-label fw-medium">Cargo</label>
                                        <input type="text" class="form-control" value="Jefe de Servicios Generales" readonly>
                                    </div>
                                    
                                    <div class="mb-3">
                                        <label class="form-label fw-medium">Área/Oficina</label>
                                        <input type="text" class="form-control" value="Oficina de Servicios Generales" readonly>
                                    </div>
                                    
                                    <div class="mb-3">
                                        <label class="form-label fw-medium">Supervisor Designado</label>
                                        <select class="form-select">
                                            <option value="">Seleccionar supervisor...</option>
                                            <option value="1">Tec. José Luis Ramírez</option>
                                            <option value="2">Ing. María Elena Vargas</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Descripción Detallada -->
                        <div class="col-12 mt-4">
                            <h6 class="text-uncp mb-3 pb-2 border-bottom">
                                <i class="fas fa-clipboard-list me-2"></i>
                                Descripción de los Servicios Prestados
                            </h6>
                            
                            <div class="mb-3">
                                <label class="form-label fw-medium">Detalle de Actividades Realizadas <span class="text-danger">*</span></label>
                                <textarea class="form-control" rows="5" placeholder="Describa detalladamente los servicios prestados durante el periodo..." required>Durante el mes de enero 2025, el CONSORCIO PICHAY ha cumplido satisfactoriamente con los servicios de limpieza y jardinería en las siguientes áreas:

1. LIMPIEZA GENERAL:
   - Limpieza diaria de aulas, laboratorios y oficinas administrativas
   - Mantenimiento de servicios higiénicos y áreas comunes
   - Limpieza de ventanas y superficies de vidrio
   - Desinfección de espacios según protocolos sanitarios

2. JARDINERÍA:
   - Mantenimiento de áreas verdes del campus universitario
   - Poda de árboles y arbustos ornamentales
   - Riego sistemático de jardines y plantas
   - Control de plagas y fertilización del césped</textarea>
                            </div>
                            
                            <div class="mb-3">
                                <label class="form-label fw-medium">Observaciones y Recomendaciones</label>
                                <textarea class="form-control" rows="3" placeholder="Observaciones adicionales, incidencias o recomendaciones...">Los servicios se han prestado de manera satisfactoria, cumpliendo con los estándares de calidad establecidos en el contrato. Se recomienda continuar con el cronograma establecido.</textarea>
                            </div>
                        </div>
                        
                        <!-- Checklist de Cumplimiento -->
                        <div class="col-12 mt-4">
                            <h6 class="text-uncp mb-3 pb-2 border-bottom">
                                <i class="fas fa-tasks me-2"></i>
                                Verificación de Cumplimiento
                            </h6>
                            
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-check mb-2">
                                        <input class="form-check-input" type="checkbox" id="check1" checked>
                                        <label class="form-check-label" for="check1">
                                            Servicios prestados conforme a especificaciones técnicas
                                        </label>
                                    </div>
                                    <div class="form-check mb-2">
                                        <input class="form-check-input" type="checkbox" id="check2" checked>
                                        <label class="form-check-label" for="check2">
                                            Cumplimiento de cronograma establecido
                                        </label>
                                    </div>
                                    <div class="form-check mb-2">
                                        <input class="form-check-input" type="checkbox" id="check3" checked>
                                        <label class="form-check-label" for="check3">
                                            Personal calificado y con equipos adecuados
                                        </label>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-check mb-2">
                                        <input class="form-check-input" type="checkbox" id="check4" checked>
                                        <label class="form-check-label" for="check4">
                                            Cumplimiento de medidas de seguridad
                                        </label>
                                    </div>
                                    <div class="form-check mb-2">
                                        <input class="form-check-input" type="checkbox" id="check5" checked>
                                        <label class="form-check-label" for="check5">
                                            Documentación de respaldo completa
                                        </label>
                                    </div>
                                    <div class="form-check mb-2">
                                        <input class="form-check-input" type="checkbox" id="check6" checked>
                                        <label class="form-check-label" for="check6">
                                            Satisfacción con la calidad del servicio
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Documentos Adjuntos -->
                        <div class="col-12 mt-4">
                            <h6 class="text-uncp mb-3 pb-2 border-bottom">
                                <i class="fas fa-paperclip me-2"></i>
                                Documentos de Sustento
                            </h6>
                            
                            <div class="mb-3">
                                <div class="table-responsive">
                                    <table class="table table-sm table-hover">
                                        <thead class="table-light">
                                            <tr>
                                                <th>Documento</th>
                                                <th>Tipo</th>
                                                <th>Fecha</th>
                                                <th class="text-center">Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <i class="fas fa-file-pdf text-danger me-2"></i>
                                                    Informe de Actividades Enero 2025.pdf
                                                </td>
                                                <td><span class="badge bg-info">Informe</span></td>
                                                <td>31/01/2025</td>
                                                <td class="text-center">
                                                    <button class="btn btn-sm btn-outline-primary me-1">
                                                        <i class="fas fa-eye"></i>
                                                    </button>
                                                    <button class="btn btn-sm btn-outline-danger">
                                                        <i class="fas fa-trash"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <i class="fas fa-file-image text-success me-2"></i>
                                                    Fotos_Evidencia_Servicios.zip
                                                </td>
                                                <td><span class="badge bg-secondary">Evidencias</span></td>
                                                <td>31/01/2025</td>
                                                <td class="text-center">
                                                    <button class="btn btn-sm btn-outline-primary me-1">
                                                        <i class="fas fa-eye"></i>
                                                    </button>
                                                    <button class="btn btn-sm btn-outline-danger">
                                                        <i class="fas fa-trash"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                
                                <button type="button" class="btn btn-outline-primary btn-sm">
                                    <i class="fas fa-plus me-1"></i>
                                    Agregar Documento
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                        Cancelar
                    </button>
                    <button type="button" class="btn btn-warning me-2">
                        <i class="fas fa-save me-1"></i>
                        Guardar Borrador
                    </button>
                    <button type="submit" class="btn btn-success">
                        <i class="fas fa-check-circle me-1"></i>
                        Emitir Conformidad
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Modal Ver Conformidad -->
<div class="modal fade" id="modalVerConformidad" tabindex="-1">
    <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header bg-info text-white">
                <h5 class="modal-title">
                <i class="fas fa-file-check me-2"></i>
                Conformidad CONF-001-2025-UNCP
                </h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body p-4">
                <div class="row">
                    <!-- Header de la Conformidad -->
                    <div class="col-12 mb-4">
                        <div class="text-center">
                            <h4 class="text-uncp mb-2">CONFORMIDAD DE PRESTACIÓN DE SERVICIOS</h4>
                            <p class="text-muted">UNIVERSIDAD NACIONAL DEL CENTRO DEL PERÚ</p>
                            <hr>
                        </div>
                    </div>
                    
                    <!-- Información del Contrato -->
                    <div class="col-md-6 mb-4">
                        <h6 class="text-uncp mb-3">Datos del Contrato</h6>
                        <table class="table table-sm table-borderless">
                            <tr>
                                <td class="fw-medium" style="width: 40%;">Contrato N°:</td>
                                <td>009-2022-LOGUNCP</td>
                            </tr>
                            <tr>
                                <td class="fw-medium">Objeto:</td>
                                <td>Servicio de Limpieza y Jardinería</td>
                            </tr>
                            <tr>
                                <td class="fw-medium">Contratista:</td>
                                <td>CONSORCIO PICHAY</td>
                            </tr>
                            <tr>
                                <td class="fw-medium">RUC:</td>
                                <td>20593790613</td>
                            </tr>
                            <tr>
                                <td class="fw-medium">Monto Total:</td>
                                <td class="text-success fw-bold">S/ 4,250,100.00</td>
                            </tr>
                        </table>
                    </div>
                    
                    <!-- Información de la Conformidad -->
                    <div class="col-md-6 mb-4">
                        <h6 class="text-uncp mb-3">Datos de la Conformidad</h6>
                        <table class="table table-sm table-borderless">
                            <tr>
                                <td class="fw-medium" style="width: 40%;">Conformidad N°:</td>
                                <td>CONF-001-2025-UNCP</td>
                            </tr>
                            <tr>
                                <td class="fw-medium">Fecha Emisión:</td>
                                <td>01/02/2025</td>
                            </tr>
                            <tr>
                                <td class="fw-medium">Periodo:</td>
                                <td>01/01/2025 - 31/01/2025</td>
                            </tr>
                            <tr>
                                <td class="fw-medium">Monto Conformado:</td>
                                <td class="text-success fw-bold">S/ 354,175.00</td>
                            </tr>
                            <tr>
                                <td class="fw-medium">Estado:</td>
                                <td><span class="badge bg-success">APROBADA</span></td>
                            </tr>
                        </table>
                    </div>
                    
                    <!-- Descripción -->
                    <div class="col-12 mb-4">
                        <h6 class="text-uncp mb-3">Descripción de Servicios Prestados</h6>
                        <div class="bg-light p-3 rounded">
                            <p>Durante el mes de enero 2025, el CONSORCIO PICHAY ha cumplido satisfactoriamente con los servicios de limpieza y jardinería en las siguientes áreas:</p>
                            
                            <p><strong>1. LIMPIEZA GENERAL:</strong></p>
                            <ul>
                                <li>Limpieza diaria de aulas, laboratorios y oficinas administrativas</li>
                                <li>Mantenimiento de servicios higiénicos y áreas comunes</li>
                                <li>Limpieza de ventanas y superficies de vidrio</li>
                                <li>Desinfección de espacios según protocolos sanitarios</li>
                            </ul>
                            
                            <p><strong>2. JARDINERÍA:</strong></p>
                            <ul>
                                <li>Mantenimiento de áreas verdes del campus universitario</li>
                                <li>Poda de árboles y arbustos ornamentales</li>
                                <li>Riego sistemático de jardines y plantas</li>
                                <li>Control de plagas y fertilización del césped</li>
                            </ul>
                        </div>
                    </div>
                    
                    <!-- Responsable -->
                    <div class="col-12 mb-4">
                        <h6 class="text-uncp mb-3">Funcionario Responsable</h6>
                        <div class="row">
                            <div class="col-md-6">
                                <p><strong>Nombre:</strong> Ing. Miguel Ángel Hurtado Sánchez</p>
                                <p><strong>Cargo:</strong> Jefe de Servicios Generales</p>
                            </div>
                            <div class="col-md-6">
                                <p><strong>Área:</strong> Oficina de Servicios Generales</p>
                                <p><strong>Fecha:</strong> 01/02/2025</p>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Firma Digital -->
                    <div class="col-12 text-center">
                        <div class="border border-success rounded p-3 bg-light">
                            <i class="fas fa-certificate text-success fa-2x mb-2"></i>
                            <p class="mb-0"><strong>CONFORMIDAD APROBADA DIGITALMENTE</strong></p>
                            <small class="text-muted">Firma digital verificada - Fecha: 01/02/2025 14:30:25</small>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-primary">
                    <i class="fas fa-download me-1"></i>
                    Descargar PDF
                </button>
                <button type="button" class="btn btn-outline-secondary">
                    <i class="fas fa-print me-1"></i>
                    Imprimir
                </button>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                    Cerrar
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Modal Observaciones -->
<div class="modal fade" id="modalObservaciones" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header bg-warning text-dark">
                <h5 class="modal-title">
                <i class="fas fa-exclamation-triangle me-2"></i>
                Observaciones - CONTRATO N° 018-2024-UNCP
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body p-4">
                <div class="alert alert-warning">
                    <i class="fas fa-info-circle me-2"></i>
                    <strong>Estado:</strong> Conformidad con observaciones que requieren subsanación
                </div>
                
                <div class="mb-4">
                    <h6 class="text-uncp mb-3">Observaciones Identificadas:</h6>
                    
                    <div class="card mb-3">
                        <div class="card-body">
                            <div class="d-flex align-items-start">
                                <i class="fas fa-exclamation-circle text-warning fa-lg me-3 mt-1"></i>
                                <div>
                                    <h6 class="mb-1">Documentación Incompleta</h6>
                                    <p class="mb-2">Falta adjuntar el informe mensual de actividades de consultoría con el detalle de horas trabajadas por consultor.</p>
                                    <small class="text-muted">Observado por: Ing. Miguel Hurtado - 15/01/2025</small>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="card mb-3">
                        <div class="card-body">
                            <div class="d-flex align-items-start">
                                <i class="fas fa-exclamation-circle text-warning fa-lg me-3 mt-1"></i>
                                <div>
                                    <h6 class="mb-1">Cronograma de Entregables</h6>
                                    <p class="mb-2">Se requiere actualización del cronograma de entregables según las modificaciones acordadas en la adenda N° 02.</p>
                                    <small class="text-muted">Observado por: Lic. Ana Torres - 16/01/2025</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="mb-4">
                    <h6 class="text-uncp mb-3">Plazo para Subsanación:</h6>
                    <div class="alert alert-info mb-0">
                        <i class="fas fa-calendar-alt me-2"></i>
                        <strong>Fecha límite:</strong> 25/01/2025<br>
                        <strong>Días restantes:</strong> <span class="badge bg-warning">3 días</span>
                    </div>
                </div>
                
                <div>
                    <h6 class="text-uncp mb-3">Acciones Requeridas:</h6>
                    <form>
                        <div class="mb-3">
                            <label class="form-label">Comentarios adicionales del revisor</label>
                            <textarea class="form-control" rows="3" placeholder="Agregue comentarios adicionales para el contratista..."></textarea>
                        </div>
                        
                        <div class="form-check mb-3">
                            <input class="form-check-input" type="checkbox" id="notificarContratista">
                            <label class="form-check-label" for="notificarContratista">
                                Notificar automáticamente al contratista vía email
                            </label>
                        </div>
                    </form>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                    Cerrar
                </button>
                <button type="button" class="btn btn-warning">
                    <i class="fas fa-paper-plane me-1"></i>
                    Enviar Observaciones
                </button>
                <button type="button" class="btn btn-success">
                    <i class="fas fa-check me-1"></i>
                    Marcar Subsanado
                </button>
            </div>
        </div>
    </div>
</div>

<script>
// Funciones para la gestión de conformidades
function buscarContratos(termino) {
    const resultados = document.getElementById('resultadosContratos');
    if (termino.length >= 3) {
        resultados.style.display = 'block';
    } else {
        resultados.style.display = 'none';
    }
}

function seleccionarContrato(elemento) {
    const contratoSeleccionado = document.getElementById('contratoSeleccionado');
    contratoSeleccionado.style.display = 'block';
    
    // Resaltar elemento seleccionado
    const items = document.querySelectorAll('#resultadosContratos .list-group-item');
    items.forEach(item => item.classList.remove('active'));
    elemento.classList.add('active');
}
</script>
